// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_Wskt1","ui_mask":"ui_mask_1YV+h"};